<template>
  <div class="column">
    利用人数 <span>おとな1名</span>
  </div>
</template>

<script>
export default {
  name: "MFITTBookingDivisionAdult",
};
</script>

<style lang="scss" scoped>
.column {
  margin: 20px 6px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.column span {
  font-weight: normal;
}
</style>
